<template>
    <header
        v-if="allowHeader"
        class="header"
        id="header"
    >
        <header-top/>
        <transition-group name="fade" mode="out-in">
            <template v-if="false">
                <header-breadcrumb :key="'header-breadcrumb'"/>
            </template>
            <template v-if="allowNav">
                <header-nav :key="'header-nav'"/>
            </template>
        </transition-group>
        <pop-toast/>
        <header-tour/>
    </header>
</template>

<script>
import HeaderTop from '@/components/default/layout/header/HeaderTop'
import HeaderBreadcrumb from '@/components/default/layout/header/HeaderBreadcrumb'
import HeaderNav from '@/components/default/layout/header/HeaderNav'
import { User } from '@/User'
import PopToast from '@/components/default/shared/PopToast'
import HeaderTour from '@/components/default/layout/header/HeaderTour'

export default {
  components: {
    HeaderTour,
    PopToast,
    HeaderNav,
    HeaderBreadcrumb,
    HeaderTop
  },
  name: 'the-header',
  data () {
    return {
      user: new User()
    }
  },
  computed: {
    allowHeader () {
      return !this.$route.meta.hiddenHeader
    },
    allowBreadcrumbs () {
      let routeName = this.$route.name

      if (!routeName) return false

      return (
        routeName !== '404' &&
      this.user.hasCustomerServices(['EBS'])
      )
    },
    allowNav () {
      let routeName = this.$route.name
      let routeMetaAllowed = this.$route.meta.allowedFor

      if (!routeName) return false

      return (
        routeName !== '404' &&
      (
        routeMetaAllowed === 'home' ||
      routeMetaAllowed === 'catalogue' ||
      (
        routeMetaAllowed === 'users' &&
      (
        (
          (
            this.user.isSuperadmin() ||
      this.user.isMasterAdministrator() ||
      this.user.isLearningExperienceAdministrator()
          ) &&
      this.user.isTokenFromNewLms()
        ) ||
      (
        this.user.isEventCoordinator() &&
      this.user.isTokenFromOldLms()
      )
      )
      ) ||
      routeMetaAllowed === 'report' ||
      routeMetaAllowed === 'admin' ||
      routeMetaAllowed === 'my-learning'
      )
      )
    },
    secondStageToken () {
      return this.$store.getters.getAuthUserSecondStageTokenData
    }
  },
  watch: {
    secondStageToken () {
      this.user = new User()
    },
    allowNav (value) {
      setTimeout(() => this.$eventBus.$emit('handle-mobile-sticky-effect'), 300)
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/layout/header/header";
</style>
